import { render, staticRenderFns } from "./comp_BookEditorInput-CoverSelector.vue?vue&type=template&id=ef096c42&scoped=true&"
import script from "./comp_BookEditorInput-CoverSelector.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorInput-CoverSelector.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorInput-CoverSelector.vue?vue&type=style&index=0&id=ef096c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef096c42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VItem,VItemGroup})
